export default __webpack_public_path__ + "fonts/a1e10adde11254f9aff2dbc8d4594c7c.woff";